<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col
          v-for="(item, i) in categories"
          :key="i"
          class="py-6 px-md-6"
          cols="12"
          md="6"
          @click="$router.push({ name: item.route })"
        >
          <!-- <div class="rowinfo"> -->
          <cat-card :item="item">
            <template>
              <help-info
                :element-name="`${serviceName}-${componentName}-catBusinessShop-${item.route}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${item.name}`"
                :style="{
                  opacity: item.comingSoon ? 0.2 : 1,
                  'pointer-events': item.comingSoon ? 'none' : 'auto',
                  top: '46%',
                  boxShadow: 'none',
                  left: '4%',
                  position: 'relative',
                }"
              />
            </template>
          </cat-card>
          <!-- </div> -->
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import CatCard from "./catCard";

export default {
  name: "catStatics",
  components: { CatCard },
  data: () => ({
    serviceName: "Qrland",
    componentName: "catStatics",
    helpData: [],

    categories: [
      // {
      //     name: 'کارت ویزیت',
      //     value: '',
      //     img: 'https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg',
      //     subtitle: 'ساخت کیو آر داینامیک بهترین روش برای شماست.',
      //     route: 'qr.cardVisit'
      // },
      // {
      //     name: 'صفحه کاری',
      //     value: '',
      //     img: 'https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg',
      //     subtitle: 'ساخت کیو آر داینامیک بهترین روش برای شماست.',
      //     route: 'qr.business'
      // },
      {
        name: "لینک",
        value: "",
        img: "https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg",
        subtitle: "اشتراک گذاری لینک با استفاده از کیوآرکد",
        route: "qr.link",
        colors: ["#FF8008", "#FFC837", "#FF8008"],
        icon: "mdi-link",
      },
      {
        name: "متن",
        value: "",
        img: "https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg",
        subtitle:
          "تمامی اطلاعات مورد نیازت را بدون هیچ محدودیتی با دنیا به اشتراک بزار",
        route: "qr.text",
        colors: ["#0093E9", "#80D0C7", "#0093E9"],
        icon: "mdi-card-text-outline",
      },
      {
        name: "ایمیل",
        value: "",
        img: "https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg",
        subtitle: "دسترسی راحت مخاطب با ایمیل،تنها با یک اسکن",
        route: "qr.mail",
        colors: ["#2c3e50", "#2980b9", "#2c3e50"],
        icon: "mdi-at",
      },
      {
        name: "تماس",
        value: "",
        img: "https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg",
        subtitle: "ایجاد پل ارتباطی آسان و سریع",
        route: "qr.call",
        colors: ["#6a3093", "#a044ff", "#6a3093"],
        icon: "mdi-phone",
      },
      {
        name: "مکان",
        value: "",
        img: "https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg",
        subtitle: "اشتراک گذاری راحت وبدون دغدغه لوکیشین",
        route: "qr.location",
        colors: ["#93291E", "#ED213A", "#93291E"],
        icon: "mdi-map-marker-outline",
        comingSoon: true,
      },
      {
        name: "پیامک",
        value: "",
        img: "https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg",
        subtitle: "پیامکتو، بدون هیچ سخت افزاری،با یک اسکن ارسال کن",
        route: "qr.sms",
        colors: ["#e43a15", "#e65245", "#e43a15"],
        icon: "mdi-message-processing",
        comingSoon: true,
      },
      {
        name: "وایفای",
        value: "",
        img: "https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg",
        subtitle:
          "دیگه نگران فراموش شدن یا اشتراک گذاری رمز عبور وای فای نباشید",
        route: "qr.wifi",
        colors: ["#FF8008", "#FFC837", "#FF8008"],
        icon: "mdi-wifi",
        comingSoon: true,
      },
      // {
      //     name: 'اینستاگرام',
      //     value: '',
      //     img: 'https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg',
      //     subtitle: 'ساخت کیو آر داینامیک بهترین روش برای شماست.',
      //     route: 'qr.instagram'
      // },
      // {
      //     name: 'توییتر',
      //     value: '',
      //     img: 'https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg',
      //     subtitle: 'ساخت کیو آر داینامیک بهترین روش برای شماست.',
      //     route: 'qr.twitter'
      // },
      // {
      //     name: 'سایت',
      //     value: '',
      //     img: 'https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg',
      //     subtitle: 'ساخت کیو آر داینامیک بهترین روش برای شماست.',
      //     route: 'qr.site'
      // },
      // {
      //     name: 'coins',
      //     value: '',
      //     img: 'https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg',
      //     subtitle: 'ساخت کیو آر داینامیک بهترین روش برای شماست.',
      //     route: 'qr.coins'
      // },
      // {
      //     name: 'شیکه های اجتماعی',
      //     value: '',
      //     img: 'https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg',
      //     subtitle: 'ساخت کیو آر داینامیک بهترین روش برای شماست.',
      //     route: 'qr.cardVisit'
      // },
      // {
      //     name: 'ویدئو',
      //     value: '',
      //     img: 'https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg',
      //     subtitle: 'ساخت کیو آر داینامیک بهترین روش برای شماست.',
      //     route: 'qr.cardVisit'
      // },
      // {
      //     name: 'عکس',
      //     value: '',
      //     img: 'https://icon-library.com/images/business-cards-icon/business-cards-icon-9.jpg',
      //     subtitle: 'ساخت کیو آر داینامیک بهترین روش برای شماست.',
      //     route: 'qr.cardVisit'
      // },
    ],
  }),
};
</script>

<style scoped></style>
